import { render, staticRenderFns } from "./DistributorStoreSettingsTab.vue?vue&type=template&id=3801df8e&scoped=true"
import script from "./DistributorStoreSettingsTab.vue?vue&type=script&lang=js"
export * from "./DistributorStoreSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./DistributorStoreSettingsTab.vue?vue&type=style&index=0&id=3801df8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801df8e",
  null
  
)

export default component.exports